<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fs_shipment"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipmentFeeStatistics_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <!-- <el-button @click="funcAdd">新增</el-button> -->
        <el-date-picker
          v-model="listQuery.gmtCreatedRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
        <el-button
          v-if="getLimit('shipmentFeeStatistics_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      :show-footer="true"
      :loading="loading"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="托运人名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入托运人名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号码"
          min-width="140"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="yingshou"
          title="应收金额"
          min-width="100"
          sortable
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              round
              @click="orderDetailMsg(scope.row)"
              >{{ scope.row.yingshou }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="yishou"
          title="已收金额"
          min-width="100"
          sortable
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              round
              @click="orderDetailMsg(scope.row)"
              >{{ scope.row.yishou }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weishou"
          title="未收金额"
          min-width="100"
          sortable
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              round
              @click="orderDetailMsg(scope.row)"
              >{{ scope.row.weishou }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1200"
      height="700"
      resize
    >
      <orderDetailList
        ref="detailRef"
        :keys="timer"
        :party-code="partyCode"
        :branch-code="branchCode"
        :is-shipment="true"
        :is-statistics="0"
        :gmt-created-range="listQuery.gmtCreatedRange"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import orderDetailList from "@/views/financialStatistics/profitFee/components/orderDetailList";

import request from "@/utils/request";

export default {
  name: "Index",
  components: {
    orderDetailList
  },
  data() {
    return {
      timer: "",
      partyCode: "",
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-tms-api/statistics/exportShipmentOrderFeeStatistics", //导出接口
        name: "托运人费用"
      },
      listQuery: {
        gmtCreatedRange: [],
        name: "", // 名称
        phone: "", // 电话
        yingshou: "", // 应收
        fasheng: "", // 发生
        yishou: "", // 已收
        gmtCreatedStart: "", // 统计时间开始
        gmtCreatedEnd: "", // 统计时间结束
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        code: ""
      },
      tuteship: false,
      // 机构列表
      branchList: this.$store.state.components.branchList,
      branchCode: ""
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/statistics/shipmentOrderFeeStatistics",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    orderDetailMsg(row) {
      this.partyCode = row.partyCode;
      this.branchCode = row.branchCode;
      this.timer = new Date().getTime();
      this.tuteship = true;
    }
  }
};
</script>

<style scoped></style>
